export type MarketDefinition = {
  id: string
  label: string
  // Pin position on the world map in Settings.
  position: string
  groups: { label?: string; places: string[] }[]
}

// Regions of the world, each broken down into the countries — and for North
// America, the states and provinces — inventory can be sold into. Shared by the
// Settings map and the per-upload recovery rules so the two never drift.
export const marketRegions: MarketDefinition[] = [
  {
    id: 'north-america',
    label: 'North America',
    position: 'left-[20%] top-[40%]',
    groups: [
      {
        label: 'United States',
        places: [
          'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia', 'Puerto Rico', 'U.S. Virgin Islands', 'Guam',
        ],
      },
      {
        label: 'Canada',
        places: [
          'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon',
        ],
      },
      { label: 'Mexico', places: ['Mexico'] },
    ],
  },
  {
    id: 'latin-america',
    label: 'Latin America',
    position: 'left-[30%] top-[72%]',
    groups: [
      {
        places: ['Argentina', 'Brazil', 'Chile', 'Colombia', 'Costa Rica', 'Dominican Republic', 'Ecuador', 'Guatemala', 'Panama', 'Peru', 'Uruguay'],
      },
    ],
  },
  {
    id: 'europe',
    label: 'Europe',
    position: 'left-[53%] top-[33%]',
    groups: [
      {
        label: 'European Union',
        places: [
          'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czechia', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden',
        ],
      },
      {
        label: 'Non-EU Europe',
        places: ['United Kingdom', 'Norway', 'Switzerland', 'Iceland', 'Serbia', 'Ukraine'],
      },
    ],
  },
  {
    id: 'middle-east',
    label: 'Middle East',
    position: 'left-[62%] top-[53%]',
    groups: [
      {
        places: ['Bahrain', 'Israel', 'Jordan', 'Kuwait', 'Oman', 'Qatar', 'Saudi Arabia', 'Turkey', 'United Arab Emirates'],
      },
    ],
  },
  {
    id: 'africa',
    label: 'Africa',
    position: 'left-[54%] top-[68%]',
    groups: [
      {
        places: ['Egypt', 'Ghana', 'Ivory Coast', 'Kenya', 'Morocco', 'Nigeria', 'Rwanda', 'Senegal', 'South Africa', 'Tanzania'],
      },
    ],
  },
  {
    id: 'asia',
    label: 'Asia',
    position: 'left-[77%] top-[47%]',
    groups: [
      {
        label: 'East Asia',
        places: ['Japan', 'South Korea', 'Taiwan', 'Hong Kong', 'China'],
      },
      {
        label: 'Southeast Asia',
        places: ['Singapore', 'Malaysia', 'Thailand', 'Indonesia', 'Philippines', 'Vietnam'],
      },
      {
        label: 'South & Central Asia',
        places: ['India', 'Sri Lanka', 'Kazakhstan'],
      },
    ],
  },
  {
    id: 'oceania',
    label: 'Oceania',
    position: 'left-[86%] top-[80%]',
    groups: [
      {
        places: ['Australia', 'New Zealand', 'Fiji'],
      },
    ],
  },
]

export function placesInRegion(regionId: string) {
  return marketRegions.find((region) => region.id === regionId)?.groups.flatMap((group) => group.places) ?? []
}

export function regionByLabel(label: string) {
  return marketRegions.find((region) => region.label === label)
}
